import { SphereBuilder as BABYLON_SphereBuilder } from '@inter-ikea-betrakta-babylonjs/core/Meshes/Builders/sphereBuilder.js';
import { StandardMaterial as BABYLON_StandardMaterial } from '@inter-ikea-betrakta-babylonjs/core/Materials/standardMaterial.js';
import { Color3 as BABYLON_Color3 } from '@inter-ikea-betrakta-babylonjs/core/Maths/math.color.js';
import { RenderingGroupID } from '../../../Viewer.js';
export class LightPositionSphere {
    constructor(light_name, scene) {
        this._sphere_size = 0.05;
        this._sphere_mesh = BABYLON_SphereBuilder.CreateSphere(light_name + ' position', { diameter: this._sphere_size }, scene);
        this._sphere_material = new BABYLON_StandardMaterial('sphere_mat', scene);
        this._sphere_material.disableLighting = true;
        this._sphere_mesh.renderingGroupId = RenderingGroupID.DEFAULT_RENDERING_GROUP;
        this._sphere_mesh.material = this._sphere_material;
    }
    update(position, line_color) {
        this._sphere_mesh.position = position;
        this._sphere_material.diffuseColor = new BABYLON_Color3(line_color.r, line_color.g, line_color.b);
        const sphere_brightness = 1;
        this._sphere_material.emissiveColor = new BABYLON_Color3(line_color.r, line_color.g, line_color.b).scale(sphere_brightness);
    }
    dispose() {
        this._sphere_mesh.dispose(true, true);
        if (this._sphere_light) {
            this._sphere_light.dispose();
        }
    }
}
//# sourceMappingURL=PositionSphere.js.map